import { StringBoolean } from '../../../types/StringBoolean';

export default function isStringTrue (inputValue: unknown): inputValue is 'true' {

  return inputValue === StringBoolean.true;

}
